
import React from 'react';

import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';

import styles from './checkbox.component.module.styl';

import type {State} from './typedef';

const classes = hashedClasses(styles);
const classNames = withCssModule(styles);

type CheckboxParamsType = State;

const CheckboxSvg = (state: CheckboxParamsType, custom: boolean) => {
    const {pressed, checked, indeterminate} = state;
    let path = [];

    if (custom) {
        path = [
            checked ? (
                <rect
                    key="minus"
                    className={classes['checkbox-button__pointer_minus']}
                    x="4"
                    y="7"
                    width="8"
                    height="2"
                />
            ) : (
                <polygon
                    key="plus"
                    className={classes['checkbox-button__pointer_plus']}
                    points="12,7 9,7 9,4 7,4 7,7 4,7 4,9 7,9 7,12 9,12 9,9 12,9 "
                />
            ),
        ];
    } else {
        path = [
            pressed ? (
                <path
                    key="r2"
                    className={classes['checkbox-button__pointer_r2']}
                    d="M14,1H2C1.5,1,1,1.5,1,2v12c0,0.5,0.5,1,1,1h12c0.5,0,1-0.5,1-1V2C15,1.5,14.5,1,14,1z M13,13H3V3h10V13z"
                />
            ) : null,
            checked ? (
                <path
                    key="checked"
                    className={classes['checkbox-button__pointer_checked']}
                    d="M14,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V2C16,0.9,15.1,0,14,0z M11.5,7.5h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-3h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1V7.5z"
                />
            ) : null,
            indeterminate ? (
                <path
                    key="nested-b"
                    className={classNames('checkbox-button__pointer_nested', 'checkbox-button__pointer_nested-b')}
                    d="M14,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V2C16,0.9,15.1,0,14,0z M15,14c0,0.5-0.5,1-1,1 H2c-0.5,0-1-0.5-1-1V2c0-0.5,0.5-1,1-1h12c0.5,0,1,0.5,1,1V14z"
                />
            ) : null,
            indeterminate ? (
                <path
                    key="nested-p"
                    className={classNames('checkbox-button__pointer_nested', 'checkbox-button__pointer_nested-p')}
                    d="M11,13H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C13,12.1,12.1,13,11,13z"
                />
            ) : null,
        ];
    }

    return (
        <svg
            aria-hidden={true}
            className={classes['checkbox-button__pointer_svg']}
            viewBox="0 0 16 16">
            <path
                className={classes['checkbox-button__pointer_r1']}
                d="M14,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V2C16,0.9,15.1,0,14,0z M15,14c0,0.5-0.5,1-1,1H2c-0.5,0-1-0.5-1-1V2c0-0.5,0.5-1,1-1h12c0.5,0,1,0.5,1,1V14z"
            />
            {path}
        </svg>
    );
};

export default CheckboxSvg;
